
















































































































































































































































































































































import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator'
import cloneDeep from 'lodash/cloneDeep'
import isEmpty from 'lodash/isEmpty'
import TaskApi from '@/api/task'
import AreaApi from '@/api/area'
import { checkCarNo, debounce } from '@/utils/util'
import addTaskMixin from './addTaskMixin'
import InvestigateApi from '@/api/investigate'
import { beforeAddTask } from '@/utils/order'
import ImageUploads from '../other/ImagesUploads.vue'
let id: any = 0

const debounceSearch = debounce(300)

@Component({
	components: {
		VNodes: {
			functional: true,
			render: (h: any, ctx: any) => ctx.props.vnodes,
		},
		ImageUploads,
	},
})
export default class FirstAudit extends Mixins(addTaskMixin) {
	public imageBlocks = [
		// {
		// 	name: '调查授权',
		// 	type: '0d01',
		// 	isMultiple: true, // 是否可多选
		// 	required: true, // 是否必填，用于提交校验
		// 	maxNum: 50,
		// },
		{
			name: '被调查人身份证复印件（可选）',
			type: '0f01',
			isMultiple: true,
			required: true,
			maxNum: 50,
		},
		{
			name: '其他（可选）',
			type: '0900',
			isMultiple: true,
			required: false,
			maxNum: 50,
		},
	]
	public mediaMap: any = {}
	public handleMediaMapChange(taskType: string, subMap: any) {
		this.$set(this.mediaMap, taskType, subMap)
	}
	public taskType: any = '5'

	public onTaskAdd(e: any) {
		e.preventDefault()
		this.addForm.validateFields(async (err: any, values: any) => {
			if (!err) {
				// validateFields存在异步校验
				// 避免快速多次的点击创建多个相同任务
				if (this.addLoading) {
					return
				}
				if (this.uploading) {
					return this.$message.info('文件上传中')
				}
				// const checkedItem = this.mediaMap[this.taskType]
				// for (let block of this.imageBlocks) {
				// 	const blockImages = (checkedItem && checkedItem[block.type]) || []
				// 	if (block.required && !(blockImages && blockImages.length > 0)) {
				// 		return this.$message.error(`请上传${block.name}`)
				// 	}
				// }
				values = cloneDeep(values)
				const codes = values.code.key.split('-')
				values.provinceCode = codes[0]
				values.cityCode = codes[1]
				values.countryCode = codes[2]
				delete values.code

				let imageList: any[] = []
				const checkedMediaMap = this.mediaMap[this.taskType]
				for (let block of this.imageBlocks) {
					const blockImages =
						(checkedMediaMap && checkedMediaMap[block.type]) || []
					imageList = imageList.concat(
						blockImages.map((imageObj: any) => ({
							picId: imageObj.picId,
							picName: imageObj.picName,
							type: block.type,
						}))
					)
				}
				values.imageList = imageList

				let mediaList: any[] = []
				if (this.fileIdMap[this.taskType]) {
					mediaList = this.fileIdMap[this.taskType].map((fileItem: any) => ({
						fileId: fileItem.fileId,
						fileName: fileItem.fileName,
					}))
				}
				values.mediaList = mediaList

				const injuredPhoneArray = this.addForm.getFieldValue(
					'injuredPhoneArray'
				)

				values.injuredPhone = injuredPhoneArray
					.reduce((arr: any, item: any) => {
						if (!isEmpty(item)) {
							arr.push(item)
						}
						return arr
					}, [])
					.join(',')
				delete values.injuredPhoneArray
				values.taskType = this.taskType
				if (this.riskDisposal) {
					values.parentOrderId = this.riskDisposal.orderId
					values.riskDetailId = this.riskDisposal.riskDetailId
					values.effectTime = values.effectTime.format('YYYY-MM-DD')
				}
				values = this.beforeSubmit(values)
				this.addLoading = true
				InvestigateApi.addTask(values)
					.then((data: any) => {
						this.$message.success(data.message || '发布成功')
						this.onOk()
					})
					.finally(() => {
						this.addLoading = false
					})
			} else {
				if (err.caseNo) {
					this.caseWaring = 'error'
					this.caseHelpMes = err.caseNo.errors[0].message
				}
			}
		})
	}
}
